import { API_EC, API_PRODUCTS_CLASSIFICATION } from '@/config/api.config';
import { axiosEc } from '@/config/axios.config';
import { getEnvConfig } from '@/config/mount-env';

/**
 * 取得商品 MainClass 樹
 */
export const getProductMainClassTree = (
    superClassId: string,
    isPostProcessing: boolean
) => {
    return axiosEc.post(
        resolveEcDirectUrl(API_EC.GET_PRODUCT_MAIN_CLASS_TREE),
        {
            RequestId: '',
            Data: {
                SuperClassID: superClassId,
                IsPostProcessing: isPostProcessing,
            },
        }
    );
};

/**
 * 取得商品 MainClass 明細
 */
export const getProductMainClassDetail = (mainClassId: string) => {
    return axiosEc.post(API_EC.GET_PRODUCT_MAIN_CLASS_DETAIL, {
        RequestId: '',
        Data: { MainClassID: mainClassId },
    });
};

/**
 * 取得後加工明細
 */
export const getProductPostProcessingDetail = (mainClassId: string) => {
    return axiosEc.post(
        resolveEcDirectUrl(
            API_PRODUCTS_CLASSIFICATION.PRODUCT_POSTPROCESSING_DETAIL
        ),
        {
            RequestId: '',
            Data: { MainClassID: mainClassId },
        }
    );
};

/**
 * 相對路徑補上 EC_BASE_URL，完整網址則原樣使用
 */
const resolveEcDirectUrl = (path: string): string => {
    const baseUrl = getEnvConfig().EC_BASE_URL || '';
    if (/^https?:\/\//i.test(path)) {
        return path;
    }
    return `${baseUrl}${path}`;
};
